/**
 * Constants file that enables/disables links and website paths
 * The navigation bar lists the links in the order shown below
 */
export default  {
    links: [
        {path: "/", name: "Home", component: "Home"},
        {path: "/UpcomingSeminar", name: "Upcoming Seminar", component: "UpcomingSeminar"},
        // {path: "/ExamResources", name: "Exam Resources", component: "ExamRes"},
        {path: "/Volunteer", name: "Volunteer", component: "Volunteer"},
        {path: "/FinancialAid", name: "Financial Aid", component: "FinAid"},
        {path: "/About", name: "About", component: "About"},
        // {path: "/Donate", name: "Donate", component: "Donate"},
    ],
}